<script lang="ts">var _a, _b, _c, _d, _e, _f, _g;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { resolveUrl } from "../../../../../js/url";
export let element;
export let sources;
$: fontFace = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.fontFace) || "";
$: button = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.button) || "";
$: buttonColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.buttonColor) || "";
$: buttonBackgroundColor = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.buttonBackgroundColor) || "";
$: buttonBorderRadius = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.buttonBorderRadius) || "4px";
$: buttonOutline = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.buttonOutline) || "";
$: clickUrl = resolveUrl(String((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.clickUrl)).href || "";
</script>

<CardBase {element}>
    <div>
        <a
        class="link"
        href={clickUrl}
        style={`color: ${buttonColor}; background: ${buttonBackgroundColor}; font-family: ${fontFace}; border-radius: ${buttonBorderRadius}; outline: ${buttonOutline}`}
        >
        {button}
        </a>
    </div>
</CardBase>

<style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.card {
  padding: 10px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: 700;
}

.description {
  font-size: 14px;
  margin: 8px 0 6px 0;
}

.link {
  display: flex;
  width: 100%;
  height: 40px;
  font-weight: 700;
  font-size: 16px;
  border-radius: 4px;
}

.img-wrapper {
  position: absolute;
  width: 148px;
  height: 155px;
  bottom: 0;
  right: 0px;
}

.img-wrapper .img {
  width: 100%;
  height: 100%;
}</style>
